import { TrendingUp, Clock, Zap } from "lucide-react";
import { Card } from "@/components/ui/card";
import { EditableText } from "@/components/admin/EditableText";

interface ROIHighlightProps {
  averageROI?: string;
  timeToResults?: string;
  timeToSetup?: string;
  onSaveROI?: (value: string) => Promise<void>;
  onSaveTimeToResults?: (value: string) => Promise<void>;
  onSaveTimeToSetup?: (value: string) => Promise<void>;
}

export const ROIHighlight = ({ 
  averageROI = "1200%", 
  timeToResults = "Instant",
  timeToSetup = "Instant",
  onSaveROI,
  onSaveTimeToResults,
  onSaveTimeToSetup
}: ROIHighlightProps) => {
  return (
    <div className="grid grid-cols-3 gap-2 w-full">
      <Card className="backdrop-blur-md bg-card/50 border border-border/50 shadow-lg p-2 md:p-4">
        <div className="flex flex-col items-center text-center space-y-0.5 md:space-y-1.5">
          <TrendingUp className="h-4 w-4 md:h-6 md:w-6 text-primary" />
          <div>
            <p className="text-[10px] md:text-xs font-medium text-muted-foreground">Average ROI</p>
            <p className="text-sm md:text-xl font-bold text-foreground">
              <EditableText value={averageROI} onSave={onSaveROI} className="inline" />
            </p>
          </div>
        </div>
      </Card>
      
      <Card className="backdrop-blur-md bg-card/50 border border-border/50 shadow-lg p-2 md:p-4">
        <div className="flex flex-col items-center text-center space-y-0.5 md:space-y-1.5">
          <Zap className="h-4 w-4 md:h-6 md:w-6 text-primary" />
          <div>
            <p className="text-[10px] md:text-xs font-medium text-muted-foreground">Time to Results</p>
            <p className="text-sm md:text-xl font-bold text-foreground">
              <EditableText value={timeToResults} onSave={onSaveTimeToResults} className="inline" />
            </p>
          </div>
        </div>
      </Card>
      
      <Card className="backdrop-blur-md bg-card/50 border border-border/50 shadow-lg p-2 md:p-4">
        <div className="flex flex-col items-center text-center space-y-0.5 md:space-y-1.5">
          <Clock className="h-4 w-4 md:h-6 md:w-6 text-primary" />
          <div>
            <p className="text-[10px] md:text-xs font-medium text-muted-foreground">Time to Setup</p>
            <p className="text-sm md:text-xl font-bold text-foreground">
              <EditableText value={timeToSetup} onSave={onSaveTimeToSetup} className="inline" />
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};
